export interface RecentUse {
  readonly id: string;
  readonly at: number;
}

export const RECENT_LIMIT = 12;

function isRecentUse(value: unknown): value is RecentUse {
  return typeof value === "object" &&
    value !== null &&
    "id" in value &&
    "at" in value &&
    typeof value.id === "string" &&
    typeof value.at === "number";
}

/** Parses stored usage; anything malformed is dropped rather than trusted. */
export function parseRecent(raw: string | null): RecentUse[] {
  if (raw === null) {
    return [];
  }
  try {
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter(isRecentUse).slice(0, RECENT_LIMIT) : [];
  } catch {
    return [];
  }
}

/** Moves id to the front, newest first, capped at RECENT_LIMIT. */
export function touchRecent(list: ReadonlyArray<RecentUse>, id: string, at: number): RecentUse[] {
  return [{ id, at }, ...list.filter((use: RecentUse): boolean => use.id !== id)].slice(0, RECENT_LIMIT);
}
